import { GETResponse } from '@cbgms/api/helpers'

export enum ProductWarrantyClaimStatus {
  Sent = 'Sent',
  InProgress = 'InProgress',
  Finalised = 'Finalised',
  Rejected = 'Rejected'
}

interface FormData {
  CompanyProductDetails: CompanyProductDetails
  WarrantyDetails: WarrantyDetails
  VehicleRelatedProducts: VehicleRelatedProducts
  AgreedToTerms: boolean
}

interface CompanyProductDetails {
  CompanyName: string
  CustomerName: string
  EmailAddress: string
  ArticleNumber: string
  ProductQuantity: number | string
  ItemDescription: string
}

interface WarrantyDetails {
  ContactPerson: string
  PurchaseDate: string
  IsTelephoneContact: boolean
  EmployeeName: string
  TransportDamage: boolean
  DiagnosisCause: string
  ChosenSolution: string
}

export const YesNoOptions = {
  YES: true,
  NO: false
} as const

export type YesNoOptions = typeof YesNoOptions[keyof typeof YesNoOptions]

export const ProductWarrantyClaimReason = {
  Technical: 'technical',
  Commercial: 'commercial'
} as const

export type ProductWarrantyClaimReason = typeof ProductWarrantyClaimReason[keyof typeof ProductWarrantyClaimReason]

export const ProductWarrantyClaimProductIs = {
  Credited: 'credited',
  Redelivered: 'redelivered'
} as const

export type ProductWarrantyClaimProductIs = typeof ProductWarrantyClaimProductIs[keyof typeof ProductWarrantyClaimProductIs]

interface VehicleRelatedProducts {
  CountryCode: string
  LicensePlate: string
  ChassisNumber: string
  DateDefect: string
  KMReadingAtInstallation: number | string
  KMReadingInCaseOfDefect: number | string
}

export interface AttachmentS3 {
  Key: string
  Name: string
  ContentType: string
  File?: File
}

export interface IProductWarrantyClaim {
  UUID: string
  CompanyUUID: string
  OrderAccountUUID: string
  WholesalerUUID: string
  CreatedAt: string
  Status: ProductWarrantyClaimStatus
  Amount: number
  Remark: string
  LicensePlate: string
  FormData: FormData
  AttachmentsS3: AttachmentS3[]
  Note: string
  ProcessedBy: string
  Assigned: boolean | null
  Reason: boolean | null
  Supplier: string
  ProductIs: boolean | null
  PackingSlip: string
  AttachmentsS3Internal: AttachmentS3[] | null
}

export interface ProductWarrantyClaimRowResponse {
  Claim: {
    UUID: string
    CaseNumber: string
    Status: string
    LicensePlate: string
    CreatedAt: string
    ArticleNumber: string
    CompanyName: string
    CustomerName: string
  }
}

export interface IProductWarrantyClaimDetails {
  Amount: number
  AttachmentsS3: AttachmentS3[]
  AttachmentsS3JSON: string
  CaseNumber: string
  CreatedAt: string
  FormData: FormData
  LicensePlate: string
  ProductNumber: string
  Remark: string
  Status: ProductWarrantyClaimStatus
  UUID: string
  CompanyUUID: string
  UpdatedAt: string
  OrderAccountUUID: string
  WholesalerUUID: string
  Note: string
  ProcessedBy: string
  Assigned: boolean | null
  Reason: boolean | null
  Supplier: string
  ProductIs: boolean | null
  PackingSlip: string
  AttachmentsS3Internal: AttachmentS3[] | null
}

export type GETRequestResponse = GETResponse<IProductWarrantyClaimDetails>
